export default __webpack_public_path__ + "static/O0076-af33bbe5c5569a11ca2abae5e76be7f8.png";